import SelectAllMatchingBanner from '@/components/table/SelectAllMatchingBanner';
import useInvitationSelectionStore from '@/stores/invitation-selection-store';
import { useTranslation } from 'react-i18next';

interface InvitationSelectAllBannerProps {
  /** Ids of the invitations on the current page. */
  pageIds: string[];
  /** Total invitations matching the current filter. */
  matchingTotal: number;
}

/**
 * Invitations-specific container around the generic SelectAllMatchingBanner:
 * wires the invitation selection store and the localized copy.
 */
const InvitationSelectAllBanner: React.FC<InvitationSelectAllBannerProps> = ({
  pageIds,
  matchingTotal,
}) => {
  const { t } = useTranslation();
  const selectedIds = useInvitationSelectionStore((s) => s.selectedIds);
  const selectAllMatching = useInvitationSelectionStore((s) => s.selectAllMatching);
  const enableSelectAllMatching = useInvitationSelectionStore((s) => s.enableSelectAllMatching);
  const clearSelection = useInvitationSelectionStore((s) => s.clearSelection);

  const allPageSelected = pageIds.length > 0 && pageIds.every((id) => selectedIds.has(id));

  return (
    <SelectAllMatchingBanner
      allPageSelected={allPageSelected}
      selectAllMatching={selectAllMatching}
      pageCount={pageIds.length}
      matchingTotal={matchingTotal}
      onSelectAllMatching={() => enableSelectAllMatching(matchingTotal)}
      onClear={clearSelection}
      labels={{
        pageSelected: t('invitations.selectAll.pageSelected', { count: pageIds.length }),
        selectMatching: t('invitations.selectAll.selectMatching', { count: matchingTotal }),
        allMatchingSelected: t('invitations.selectAll.allMatchingSelected', {
          count: matchingTotal,
        }),
        clear: t('invitations.selectAll.clear'),
      }}
    />
  );
};

export default InvitationSelectAllBanner;
